import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

import { Col } from '@amzn/stencil-react-components/layout'
import { Link } from '@amzn/stencil-react-components/link';
import { Text } from '@amzn/stencil-react-components/text'
import {MOCK_ID} from "../../../utils/testConstants";

class ArticleWithoutVideo extends Component {

    render() {
        const { t } = this.props
        return(
            <Col dataTestId={MOCK_ID.ARTICLE_WITHOUT_VIDEO} gridGap="S300">
                <Text dataTestId="Article_Title" fontWeight="bold">{this.props.title}</Text>
                <Text dataTestId="Article_Description">{this.props.description}</Text>
                {this.props.haveAdditionalArticleDialog &&
                    <Link dataTestId="Read_More_Link" href="#" onClick={this.props.readMoreClickHandler}>
                      {t('HelpfulInformation.Article.ReadMore')}</Link>
                }
            </Col>
        );
    }
}

export default withTranslation('translationsV2')(ArticleWithoutVideo)
